import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EuFlagIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_jsxs("svg", {
    width: "25",
    height: "16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    viewBox: "0 0 25 16",
    children: [/*#__PURE__*/_jsxs("g", {
      "clip-path": "url(#a)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M.5 0h24v16H.5V0Z",
        fill: "#039"
      }), /*#__PURE__*/_jsx("path", {
        d: "m12.498 1.774.2.614h.649l-.523.38.197.614-.523-.38-.522.38.2-.614-.523-.38h.646l.2-.614Zm-2.666.71.2.615h.648l-.522.38.196.614-.522-.38-.523.38.2-.614-.523-.38h.646l.2-.614ZM7.876 4.44l.2.614h.649l-.523.38.197.614-.523-.38-.522.38.2-.614-.523-.38h.646l.2-.614Zm-.71 2.667.199.614h.648l-.522.38.197.614-.523-.38-.522.38.2-.614-.523-.38h.646l.2-.614Zm.71 2.667.2.614h.649l-.523.38.197.614-.523-.38-.522.38.2-.614-.523-.38h.646l.2-.614Zm1.956 1.955.2.614h.648l-.522.38.196.614-.522-.38-.523.38.2-.614-.523-.38h.646l.2-.614Zm5.333-9.244.2.614h.649l-.523.38.197.614-.523-.38-.522.38.2-.614-.523-.38h.646l.2-.614Zm1.956 1.955.2.614h.648l-.522.38.196.614-.522-.38-.523.38.2-.614-.523-.38h.646l.2-.614Zm.71 2.667.2.614h.65l-.523.38.196.614-.522-.38-.523.38.2-.614-.523-.38h.646l.2-.614Zm-.71 2.667.2.614h.648l-.522.38.196.614-.522-.38-.523.38.2-.614-.523-.38h.646l.2-.614Zm-4.622 2.667.2.613h.648l-.523.38.197.615-.523-.38-.522.38.2-.615-.523-.38h.646l.2-.614Zm2.666-.712.2.614h.649l-.523.38.197.614-.523-.38-.522.38.2-.614-.523-.38h.646l.2-.614Z",
        fill: "#FC0"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          transform: "translate(.5)",
          d: "M0 0h24v16H0z"
        })
      })
    })]
  });
}